export default __webpack_public_path__ + "static/media/Pot3.903aa06f.svg";